import React from "react";
import { useContainerQuery } from "react-container-query";
import { useReactAppState } from "../../../shared/containers/utils";
import { query } from "../../../shared/styled/Theme";
import { MatchFragmentWrapper } from "./MatchFragmentWrapper";

export const MatchWrapper = ({
  d3Match,
  statsAPIMatch,
  showSecondaryTeams = false,
  showClubRanks = false,
  showCompetitionStage = false,
  showRoundDetail = false,
  showGroupInformation = false,
  hideMatchPromos = false,
  position = null,
}) => {
  const { urlList, directoryList } = useReactAppState();
  const { baseUrl } = urlList || {};
  const { matchHubDir } = directoryList || {};
  const { match_id: matchSportecId } = statsAPIMatch || {};
  const { competition = {}, season, slug } = d3Match || {};
  const { name: seasonName } = season || {};
  const { slug: competitionSlug } = competition || {};

  const matchPageUrl = competitionSlug && slug ?
    `${baseUrl}/${matchHubDir}/${competitionSlug}/${seasonName}/matches/${slug}`
    : null;

  const [params, containerRef] = useContainerQuery(query);

  if (!statsAPIMatch || !d3Match) {
    return null;
  }

  return (
    <MatchFragmentWrapper
      d3Match={d3Match}
      position={position}
      matchSportecId={matchSportecId}
      matchPageUrl={matchPageUrl}
      containerRef={containerRef}
      statsAPIMatch={statsAPIMatch}
      showClubRanks={showClubRanks}
      showCompetitionStage={showCompetitionStage}
      showRoundDetail={showRoundDetail}
      showGroupInformation={showGroupInformation}
      params={params}
      hideMatchPromos={hideMatchPromos}
    />
  );
};
